export const FREE_PLAN = 'free'
export const STARTER_PLAN = 'essentials'
export const PRO_PLAN = 'professional'
export const GROWTH_PLAN = 'growth'
export const ENTERPRISE_PLAN = 'enterprise'
